export default __webpack_public_path__ + "static/media/spring-web-mvc.40404332.png";